import { ApplicationLaunchRequest } from "./ApplicationLaunchRequest";

export class ApplicationsLaunchRequest {
  requests: ApplicationLaunchRequest[];
}
